(function () {
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);

    function searchArticles() {

        // grab all the articles
        const articles = section.querySelectorAll(".articleCardV2") || false;

        //Setup search parameters
        // Push search parameters to this array to be looped through
        const searchParameters = []

        //Checks for if matches have been found
        let foundCategoryMatch = false;
        let foundTagMatch = false;
        let foundSearchMatch = false;

        //1. use search bar parameters and a regex to search for patters in article titles and excerpts
        const articleSearchBar = section.querySelector('#blogV2SearchInput[name="Search_Articles"]');
        let searchValue = articleSearchBar.value;

        //If we have a search bar value and articles exists, save the normalized search bar value
        if (searchValue && articles) {
            //Normalize the search value and save it
            searchValue = searchValue.toLowerCase().trim()
        }

        //2. loop through all checked inputs and save the value to the search params array
        section.querySelectorAll(".articleSearchInput").forEach((element) => {
            if (element.checked && element.value !== "") {
                //Normalize and save the value if it exists
                const value = element.value.toLowerCase().trim();
                searchParameters.push(value);
            }
        });


        articles.forEach(article => {
            article.classList.remove("active")
        });

        articles.forEach(article => {
            //Normalize article text for clean searching
            const articleTitle = JSON.parse(article.dataset.title).toLowerCase().trim();
            const articleExcerpt = JSON.parse(article.dataset.excerpt).toLowerCase().trim();

            // If the search bar value is present in the article content, show that article
            if (searchValue !== "" && (articleTitle.includes(searchValue) || articleExcerpt.includes(searchValue))) {
                foundSearchMatch = true;
                console.log("Search match");
                article.classList.add("active");
            }

            //Search through article categories for matches
            // Shows article even if one match is found
            if (searchParameters.length === 1 && searchParameters[0] === "all") {
                article.classList.add("active");
            } else {
                const articleCategories = JSON.parse(article.dataset.categories);
                if (articleCategories) {
                    const normArticleCategories = articleCategories.map(category => category.toLowerCase().trim());
                    if (normArticleCategories.some(element => searchParameters.includes(element))) {
                        article.classList.add("active");
                        foundCategoryMatch = true;
                        console.log("Category Match");
                    }
                }
            }

            //Search through article tags for matches
            // Shows article even if one match is found.
            const articleTags = JSON.parse(article.dataset.tags);
            if (articleTags) {
                const normArticleTags = articleTags.map(tag => tag.toLowerCase().trim());
                if (normArticleTags.some(element => searchParameters.includes(element))) {
                    article.classList.add("active");
                    foundTagMatch = true;
                    console.log("Tag Match");
                }
            }
        });

        //If no matches found, Display a message and show 10 articles
        if (!foundCategoryMatch && !foundTagMatch && !foundSearchMatch) {
            for (let i = 0; i < 10; i++) {
                articles[i].classList.add("active");
            }
        }
        // Check for the search value in the text content of the articles
        //2a. Check categories first

        //2b. Check tags

        //3. Set any articles that are matches to active, and hide all other others
        // May need to hide all articles first.

        //4. if no articles found, display a message.

    }


    section.querySelectorAll(".articleSearchInput").forEach((element) => {
        element.addEventListener("change", searchArticles);
    });

    function debounce(func, delay = 300) {
        let timerId;

        return function (...args) {
            // Clear the previous timer if the function is called again before the delay expires
            clearTimeout(timerId);

            // Set a new timer to execute the function after the specified delay
            timerId = setTimeout(() => {
                func.apply(this, args);
            }, delay);
        };
    }

    const debouncedSearchArticles = debounce(searchArticles, 1500);

    section.querySelector('#blogV2SearchInput[name="Search_Articles"]').addEventListener('input', (e) => {
        debouncedSearchArticles();
    });

    function searchTags() {
        // Grab all tags
        const childTags = section.querySelectorAll(".childTag");
        const parentTags = section.querySelectorAll(".parentTag");

        let tagsFiltered = false;

        childTags.forEach(tag => {
            tag.classList.remove("active");
        });

        const tagSearchBar = section.querySelector('#blogV2SearchTagsInput[name="Search_Tags"]');
        let searchValue = tagSearchBar.value;
        searchValue = searchValue.toLowerCase().trim();

        childTags.forEach(tag => {
            if ((tag.dataset.name).trim() === searchValue) {
                tagsFiltered = true;
                tag.classList.add("active");
            }
        })

        parentTags.forEach(parent => {
            const parentInput = parent.querySelector(".blogV2AsideTagsParentItemInput");
            if (parentInput.checked) {
                tagsFiltered = true;
                childTags.forEach(child => {
                    if (child.dataset.parent === parent.dataset.name) {
                        child.classList.add("active");
                    }
                });
            }
        });

        if (!tagsFiltered) {
            childTags.forEach(tag => {
                tag.classList.add("active");
            })
        }
    }

    const debouncedSearchTags = debounce(searchTags, 800);

    section.querySelector('#blogV2SearchTagsInput[name="Search_Tags"]').addEventListener('input', (e) => {
        debouncedSearchTags();
    });

    section.querySelectorAll(".parentTag").forEach(tag => {
        tag.addEventListener("change", (e) => {
            searchTags();
        })
    });

    // Hide featured articles when "ALL" button is not selected
    section.querySelectorAll(".blogV2CategoriesItemInput").forEach((item) => {
        item.addEventListener("change", (e) => {
            if (item.value === "all") {
                section.querySelector(".blogV2Featured").classList.add("active");
            } else {
                section.querySelector(".blogV2Featured").classList.remove("active");
            }
        })
    })
}());
